// apps/dashboard/src/hooks/use-nps.ts
// Hooks for in-app NPS survey (Sprint AM).
// SPEC: docs/specs/tenant/sprint-am-nps.spec.md

import { api } from '@/lib/api';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export interface NpsSurveyDto {
  id: string;
  triggeredAt: string;
}

export function useNpsSurvey() {
  return useQuery<{ survey: NpsSurveyDto | null }>({
    queryKey: ['me', 'nps-survey'],
    queryFn: () => api.get('/me/nps-survey'),
    // Refetch every 5 minutes — low priority
    staleTime: 5 * 60 * 1000,
  });
}

export function useNpsRespond() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: { surveyId: string; score: number; comment?: string }) =>
      api.post<{ ok: boolean; category: string }>('/me/nps-survey/respond', payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['me', 'nps-survey'] });
    },
  });
}

export function useNpsDismiss() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: { surveyId: string }) =>
      api.post<{ ok: boolean }>('/me/nps-survey/dismiss', payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['me', 'nps-survey'] });
    },
  });
}
